import { InfoCircleOutlined } from '@ant-design/icons';
import { Select, Tooltip, Typography } from 'antd';

import { SOCIAL_INTEGRATIONS_CHANNELS_FOR_COMMUNICATION } from '@app/components/Modals/BotDetailsModal/data/socialIntegrations';
import {
  DEFAULT_CHANNEL_INDEX,
  LOYALTY_PROGRAM_SENDOUTS,
  RULES_IS_REQUIRE,
} from '@app/constants';
import { FormItem } from '@app/pages/TasksList/components';

import type { FormInstance } from 'antd';
import type { BaseOptionType } from 'antd/es/select';

const { Text } = Typography;

const searchProps = {
  showSearch: true,
  optionFilterProp: 'label',
};

interface SocialChannelFieldsProps {
  form: FormInstance;
  socialIntegrationTypeValue: number | string | null | undefined;
  filteredIntegrations: BaseOptionType[];
  handleChannelOptions: (fieldName: string) => void;
  required?: boolean;
  defaultChannelLabel?: string;
}

export const SocialChannelFields = ({
  form,
  socialIntegrationTypeValue,
  filteredIntegrations,
  handleChannelOptions,
  required = true,
  defaultChannelLabel = 'Последний активный канал',
}: SocialChannelFieldsProps) => {
  const rules = required ? [...RULES_IS_REQUIRE] : undefined;

  return (
    <>
      <FormItem
        name="socialIntegrationType"
        label="Канал"
        require={required}
        rules={rules}
      >
        <Select
          onChange={() => {
            form.resetFields(['socialIntegrationId']);
            handleChannelOptions('socialIntegrationType');
          }}
          placeholder={required ? 'Выберите канал связи' : defaultChannelLabel}
          options={[
            { value: DEFAULT_CHANNEL_INDEX, label: defaultChannelLabel },
            ...SOCIAL_INTEGRATIONS_CHANNELS_FOR_COMMUNICATION,
          ]}
        />
      </FormItem>

      <FormItem
        name="socialIntegrationId"
        label={
          <Text className={required ? 'label-require' : undefined}>
            Интеграция{' '}
            <Tooltip
              title={`Чтобы разблокировать поле, выберите канал, отличный от «${defaultChannelLabel}».`}
            >
              <InfoCircleOutlined />
            </Tooltip>
          </Text>
        }
        rules={rules}
      >
        <Select
          disabled={
            !socialIntegrationTypeValue ||
            socialIntegrationTypeValue === DEFAULT_CHANNEL_INDEX ||
            socialIntegrationTypeValue === LOYALTY_PROGRAM_SENDOUTS
          }
          placeholder="Выберите интеграцию"
          options={filteredIntegrations}
          {...searchProps}
        />
      </FormItem>
    </>
  );
};
